<template>
    <div class="container">
      <div
        style="
          height: 262px;
          width: 100%;
          background: linear-gradient(
            0deg,
            #0e0f34 0%,
            #12153d 49%,
            #0e1036 100%
          );
          z-index: 1;
        "
      ></div>
      <div class="content">
        <div class="content-header">
          <div class="content-title">当前学习课程</div>
          <el-button
            style="color: #dc2325; background: transparent; margin-right: 20px"
            @click="$router.go(-1)"
            >返回</el-button
          >
        </div>
        <div class="content-body">
          <div class="video">
            <video-player
             class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsinline="true"
              :options="playerOptions"
              @play="onPlayerPlay($event)"
              @pause="onPlayerPause($event)"
              @timeupdate="onPlayerTimeupdate($event)"
              @ended="onPlayerEnded($event)"
            ></video-player>
          </div>
          <div class="ml">
            <h3 class="ml-title">{{ $route.query.liveName }}</h3>      
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { videoPlayer } from "vue-video-player";
  import "videojs-contrib-hls";
  import "video.js/dist/video-js.css";
  import "vue-video-player/src/custom-theme.css";
  
  export default {
    name: "index",
    data() {
      return {
        videoList: [],
        activeChapter: 0,
        playerOptions: {
          language: "zh-CN",
          aspectRatio: "16:9",
          sources: [{
            type: "application/x-mpegURL",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "" //url地址
          }],
        },
        paused: true,
      };
    },
    components: {
      videoPlayer,
    },
    mounted() {
    },
    destroyed() {
      // if (this.timer) {
      //   clearInterval(this.timer)
      // }
    },
    computed: {
      player() {
        return this.$refs.videoPlayer.player;
      },
    },
    beforeDestroy() {
      // this.addChapterPlay(this.player)
      // document.removeEventListener(this.visibilityChangeEvent)//this.onVisibilityChange)
    },
    methods: {
      getVideo() {
        this.$nextTick(()=>{
          this.playerOptions.sources[0].type =  this.$route.query.liveUrl.indexOf("m3u8") === -1? "video/mp4": "application/x-mpegURL"
          this.playerOptions.sources[0].src =  this.$route.query.liveUrl
          // setTimeout(() => {
          //   this.$refs.videoPlayer.player.play()
          //   console.log(this.$refs.videoPlayer,'我笑死')
          // }, 2000);   
        })
      },
      // onVisibilityChange() { // 检测当前页面是否显示
      //   if (!document[this.hiddenProperty]) {
      //     this.player.play()
      //   } else {
      //     this.player.pause()
      //   }
      // },
      // eslint-disable-next-line no-unused-vars
      onPlayerPlay(player) {
        this.paused = false;
        if (this.currentTime) {
          this.player.currentTime(this.currentTime);
        }
      },
      // eslint-disable-next-line no-unused-vars
      onPlayerTimeupdate(player) {
        // this.disabledSeek(player)
      },
      // eslint-disable-next-line no-unused-vars
      onPlayerPause(player) {
        this.paused = true;
        // this.flush()
      },
      onPlayerEnded() {
        // 播放结束
        this.paused = true;
        //   this.addChapterPlay(player);
        // this.flush();
        this.playerOptions.controls = true;
      },
      // disabledSeek(player) {
      //   //禁止跳转
      //   let beforeTime = this.beforeTime || 0;
      //   if (player.cache_.currentTime - beforeTime >= 2) {
      //     this.player.currentTime(this.beforeTime);
      //   } else {
      //     this.beforeTime = player.cache_.currentTime;
      //   }
      //   // this.beforeTime = player.cache_.currentTime;
      // },
      // addChapterPlay(player) {
      //   // 记录进度
      //   if (!this.paused) {
      //     api.addChapterPlay({
      //       userId: cookie.getCookie('userId'),
      //       videoId: this.videoInfo.videoId,
      //       videoPosition: player.cache_.currentTime,
      //       videoTime: player.cache_.duration,
      //       watchEnd: 0
      //     }).then(res => {
      //       // console.log(res.data)
      //     });
      //   }
      // },
      // flush() {
      //   api.flush(this.$route.query.id, cookie.getCookie('userId'), this.videoInfo.videoId,2020).then(res => {
      //     console.log(res)
      //   })
      // },
      // fh() {
      //   this.flush()
      //   this.$router.push('/learn')
      // }
    },
    created() {
      this.getVideo();
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .vjs-big-play-button {
    top: 50% !important;
    left: 50% !important;
    margin: -0.75em 0 0 -1.5em !important;
  }
  .content {
    width: 1200px;
    margin: 20px auto;
  
    .content-header {
      background: #191919;
      display: flex;
      justify-content: space-between;
      align-items: center;
  
      .content-title {
        padding: 20px;
        color: #ffffff;
      }
    }
  
    .content-body {
      display: flex;
      align-items: center;
      .video {
        width: 890px;
      }
      .ml {
        width: 310px;
        height: 501px;
        text-align: center;
        background: #2d2d2d;
        color: #ffffff;
        padding-bottom: 20px;
      box-sizing: border-box;
  
        span {
          display: block;
          // padding: 20px;
          cursor: pointer;
        }
        span.active {
          color: #1e90ff;
        }
      }
    }
  }
  </style>
  